export const AUTHORIZATION_COOKIE_KEY = 'authorization'

export const REMEMBER_ME_COOKIE_KEY = 'login'
export const REMEMBER_ME_COOKIE_EXPIRATION_DAYS = 30

export const SWITCH_SESSION_COOKIE_KEY = 'alt-login'

export const LOGIN_SESSION_DATA_LOCAL_STORAGE_KEY = 'login-session'

export const ORIGIN_REQUEST_LOGIN = 'login'
export const ORIGIN_REQUEST_RESET = 'reset'
export const RESET_PATH_REGEX = 'resetpassword'

export const AUTH_STATE_LOGIN = 'login'

export const AI_IMAGES_SOCKET_SERVICE_NAME = 'AIImages'

export const SOCKET_EVENT_NAMES = {
  [AI_IMAGES_SOCKET_SERVICE_NAME]: {
    RESULT_PUBLISHED: 'resultPublished',
    IMAGE_VALIDATIONS_READY: 'imageValidationsReady'
  }
}

export const BROWSER_TYPE_VW = 1
export const BROWSER_TYPE_VW_EMBEDDED = 2